
import { connect } from 'react-redux';
import Users from './Users';
import { setProgressBarStatus } from '../../redux/actions/progressBar';

const mapStateToProps = null;

const mapDispatchToProps = {
  setProgressBarStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);
